/* eslint-disable @typescript-eslint/indent */
import { reportAegisError } from '@/utils/aegis';
import dayjs from 'dayjs';
import uuid from 'uuid';
import { DOCTOR_INFO } from '@/const/storage';
import fly from './http';
import { CheckRulesParams } from '@/components/type/type';
import { ElUploadInternalFileDetail } from 'element-ui/types/upload';
import { UPLOAD_IMAGE_URL, DOWNLOAD_IMAGE_URL } from '@/const/business';
import element from 'element-ui';
import { HOSPITAL_CONFIG } from '@/config/hospital';
import defaultAvatar from '@/assets/images/avatar-default.png';
import maleAvatar from '@/assets/images/avatar-male.png';
import femaleAvatar from '@/assets/images/avatar-female.png';
/**
 * 获取年龄
 * @param {string} birthday
 */
export const getAge = (birthday: string) => {
  if (!birthday || birthday === '0000-00-00') return '';

  const birthdayStr = dayjs(birthday);
  const today = dayjs();
  let age = today.year() - birthdayStr.year();
  const birthMonth = birthdayStr.month();
  const nowMonth = today.month();
  if (birthMonth > nowMonth || (birthMonth === nowMonth && birthdayStr.date() > today.date())) {
    age = age - 1;
  }
  return age;
};

interface Params {
  service?: string;
  func: string;
  commonIn?: Object;
  req?: Object;
  sourceType?: number;
}

// 请求参数处理
export const getParamsDeal = (params: Params) => {
  const commonIn = Object.prototype.hasOwnProperty.call(params, 'commonIn')
    ? params.commonIn
    : {
        requestId: uuid(),
        sourceType: params.sourceType, // ! 传入了sourceType为 1 表示 表单下发的接口
      };
  return {
    service: params.service || 'ArchiveHospitalServer',
    func: params.func,
    args: {
      commonIn: { ...commonIn, requestId: uuid() },
      req: params.req || {},
    },
  };
};

// 请求处理
export const requestInfo = async (params) => {
  const commonIn = Object.prototype.hasOwnProperty.call(params, 'commonIn')
    ? params.commonIn
    : {
        requestId: uuid(),
      };
  const prefixApi = params.prefixApi ? params.prefixApi : 'early_screen';
  const res: any = await fly.post(`/${prefixApi}/${params.api}`, {
    commonIn: { ...commonIn, requestId: uuid() },
    ...params.req,
  });
  if (res.err) throw Error('弹窗拦截');
  return res;
};

// 获取医生信息
// 废弃 请使用getDoctorInfo获取
export const getDoctorInfoStorage = () => {
  const doctorInfoStr = localStorage.getItem(DOCTOR_INFO);
  let doctorInfo = {
    avatarUrl: '',
    canSendMsg: '',
    departmentId: '',
    departmentName: '',
    doctor_id: '',
    doctor_name: '',
    hospitalId: 10001,
    hospitalName: '',
    showDataPlatformTab: '',
    showFollowUpTab: '',
    showPatientRecruitTab: '',
    showQuestionnaireFlag: '',
    speciality: '',
    title: '',
    showSmartForm: '',
    showAfterDiagnosisPlan: '',
    showPatientList: '',
    canCreateMsg: '',
    showSendSMS: '',
    showAutoReply: '',
    isCheckAllInPatients: 1,
    isCheckAllOutPatients: 1,
    departmentList: [],
    showConfigStatistics: '',
    showPreciseStatistics: '',
    showQaConfig: '',
    showQaStatistics: '',
    showHisJumpUrl: '',
    showInHisJumpUrl: '',
    showGroupAutoImport: '',
    showWorkbench: '',
    showInHospitalTool: '',
    showFamilyDoctorModule: '',
    showPrepareVisit: '',
    showDoctorEditFollow: '',
    userType: '',
    showSpecialDisease: '',
    showChildPlanConditionTrigger: '',
    showCallOut: '',
    userId: 0,
    partnetKeyDate: '',
  };
  if (doctorInfoStr) {
    doctorInfo = JSON.parse(doctorInfoStr);
  }
  return doctorInfo;
};
export const getDoctorInfo = async () => {
  const doctorInfoCache = localStorage.getItem(DOCTOR_INFO);
  if (doctorInfoCache) {
    return JSON.parse(doctorInfoCache);
  }
  return await refreshDoctorInfo();
};
export const refreshDoctorInfo = async (doctorInfo?: any) => {
  if (doctorInfo) {
    localStorage.setItem(DOCTOR_INFO, doctorInfo);
    return doctorInfo;
  }
  const { err, rsp } = (await fly.post('/hospital/getUserInfo')) as any;
  if (rsp && !err) {
    localStorage.setItem(DOCTOR_INFO, JSON.stringify(rsp));
    return rsp;
  }
  return {};
};

// 补齐成两位数
export const formatNumber = (n: string) => {
  n = n.toString();
  return n[1] ? n : `0${n}`;
};

// 自定义文本配置
export const editorConfig = {
  height: 200,
  auto_focus: false,
  toolbar:
    'undo redo | '
    + 'blocks | '
    + 'formatselect | '
    + 'fontsizeselect fontselect  styleselect | '
    + 'forecolor  underline strikethrough | '
    + 'bold italic backcolor  | hr alignleft aligncenter '
    + 'alignright alignjustify | bullist numlist outdent indent | '
    + 'removeformat | image manageImages table link fullscreen | help',
  plugins:
    'image textcolor imagetools  advlist fullscreen link lists hr help autolink charmap preview anchor  searchreplace visualblocks insertdatetime hr table paste wordcount autoresize', // 选择需加载的插件
  fontsize_formats: '8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 24pt 36pt 48pt',
  font_formats:
    '微软雅黑=\'微软雅黑\';宋体=\'宋体\';黑体=\'黑体\';仿宋=\'仿宋\';楷体=\'楷体\';隶书=\'隶书\';幼圆=\'幼圆\';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings',
  paste_data_images: true,
  branding: false,
  insertdatetime_formats: ['%r', '%H:%M:%S', '%H点%M分%S秒', '%D', '%Y-%m-%d', '%Y年%m月%d日', '%A', '%a'],
  style_formats: [
    {
      title: '行高',

      items: [
        { title: '1', block: 'p', styles: { 'line-height': '1.0' } },

        { title: '1.5', block: 'p', styles: { 'line-height': '1.5' } },

        { title: '1.75', block: 'p', styles: { 'line-height': '1.75' } },

        { title: '2', block: 'p', styles: { 'line-height': '2' } },

        { title: '3', block: 'p', styles: { 'line-height': '3' } },

        { title: '4', block: 'p', styles: { 'line-height': '4' } },

        { title: '5', block: 'p', styles: { 'line-height': '5' } },
      ],
    },
  ],
  images_upload_handler(blobInfo, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open('POST', UPLOAD_IMAGE_URL);

    xhr.onload = function () {
      if (xhr.status !== 200) {
        failure(`HTTP Error: ${xhr.status}`);
        return;
      }

      const json = JSON.parse(xhr.responseText);
      if (json && json.code === 0 && json.data.rid) {
        success(`${DOWNLOAD_IMAGE_URL}${json.data.rid}`);
      } else {
        failure('图片上传失败');
      }
    };

    const formData = new FormData();
    formData.append('file', blobInfo.blob(), blobInfo.filename());

    xhr.send(formData);
  },
};

// 正负小数正则
export const decimalsReg = /^(-[1-9][\d]*|[1-9][\d]*|0)(\.[\d]+)?$/;

// 整数正则
export const integerReg = /^0$|(^[1-9]\d*$)/;

// 正整数正则
export const positiveNumberReg = /^[1-9]\d*$/;

// 手机正则
export const phoneReg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;

// 校验规则
export const checkRules = (params: CheckRulesParams = {}) => {
  if (!Object.prototype.hasOwnProperty.call(params, 'message')) params.message = '您的项目设置不完整';
  if (!Object.prototype.hasOwnProperty.call(params, 'required')) {
    params.required = true;
  }
  return [
    {
      ...params,
      trigger: ['blur', 'change'],
    },
  ];
};

/**
 * @description 基于async异步函数的throttle，内部逻辑(包含异步行为)没完成前不允许二次触发
 * @description 为什么不耦合普通throttle?逻辑解耦，调用者需要明确自己需要的行为
 */
export const asyncThrottle = (callback) => {
  let isLocking = false;
  return async function (this: any, ...args: any[]) {
    if (isLocking) return;
    isLocking = true;
    const startTime = new Date().getTime();
    try {
      await callback.apply(this, args);
    } catch (err: any) {
      if (!err.toString().includes('弹窗拦截')) {
        reportAegisError({
          type: 'UNHANDLED_ERROR',
          error: err?.stack || err.toString(),
        });
      }
    } finally {
      const timeInterval = new Date().getTime() - startTime;
      if (timeInterval > 1500) {
        isLocking = false;
      }
      setTimeout(() => {
        isLocking = false;
      }, 1500 - timeInterval);
    }
  };
};

// 姓名掩码
export const mosaicName = (name: string) => {
  if (!name) return '--';
  if (name.length === 1) return name;
  if (name.length === 2) return `${name[0]}*`;
  if (name.length === 4) return `${name.substring(0, 2)}**`;
  return `${name[0]}*${name[name.length - 1]}`;
};

// 身份证掩码
export const mosaicIdCard = (cardNumber: string) => {
  if (!cardNumber) return '';
  return `${cardNumber.slice(0, 4)}**********${cardNumber.slice(14, 18)}`;
};

// 备注内容API请求参数处理
export const getRemarkParamsDeal = async (params: Params) => {
  let doctorInfoData = {
    departmentName: '',
    doctorId: '',
    doctorName: '',
    hospitalId: '',
    hospitalName: '',
    departmentId: '',
  };
  const doctorParams = localStorage.getItem('doctorInfo');
  if (doctorParams) {
    const storageParams = JSON.parse(localStorage.getItem('doctorInfo') || '');
    doctorInfoData = {
      departmentName: storageParams.departmentName,
      doctorId: storageParams.doctor_id,
      doctorName: storageParams.doctor_name,
      hospitalId: storageParams.hospitalId,
      hospitalName: storageParams.hospitalName,
      departmentId: storageParams.departmentId,
    };
  } else {
    const rsp = await refreshDoctorInfo();
    if (rsp) {
      doctorInfoData = {
        departmentName: rsp.departmentName,
        doctorId: rsp.doctor_id,
        doctorName: rsp.doctor_name,
        hospitalId: rsp.hospitalId,
        hospitalName: rsp.hospitalName,
        departmentId: rsp.departmentId,
      };
    }
  }
  const commonIn = Object.prototype.hasOwnProperty.call(params, 'commonIn')
    ? params.commonIn
    : {
        requestId: uuid(),
      };
  return {
    service: params.service || 'PatientRemarksServer',
    func: params.func,
    args: {
      commonIn,
      req: {
        doctorInfo: {
          ...doctorInfoData,
        },
        ...params.req,
      },
    },
    commonIn: {
      requestId: uuid(),
    },
  };
};

export const dealRemark = remarkList => remarkList?.toString();

export const throttle = (fn: (...arg: any[]) => any, duration = 500) => {
  let timer = -1;
  return function (this: unknown, ...args: any[]) {
    if (timer > -1) {
      clearTimeout(timer);
    }
    timer = window.setTimeout(() => {
      fn.bind(this)(...args);
      timer = -1;
    }, duration);
  };
};

/**
 * 根据上传的file获取到文件size&临时预览地址
 * ps: createObjectURL很快，但是要注意释放内存
 */
export const getFileSize = (
  file: ElUploadInternalFileDetail,
  fileType: 'image' | 'video',
): Promise<{ width: number; height: number; url: string }> => {
  const url = URL.createObjectURL(file.raw);
  return new Promise((resolve, reject) => {
    if (fileType === 'image') {
      const ele = new Image();
      ele.onload = function () {
        resolve({
          width: ele.width,
          height: ele.height,
          url,
        });
      };
      ele.onerror = reject;
      ele.src = url;
    } else {
      const ele = document.createElement('video');
      ele.onloadeddata = function () {
        resolve({
          width: ele.videoWidth,
          height: ele.videoHeight,
          url,
        });
      };
      ele.onerror = reject;
      ele.setAttribute('preload', 'auto');
      ele.src = url;
    }
  });
};

export const loadScript = (jsUrl = '') => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = jsUrl;
  document.getElementsByTagName('head')[0].appendChild(script);
};

export const sourceNingxiaUrl = () => {
  const { hash } = window.location;
  const loginPage = hash.match('dataAnalysisLogin') || [];
  const ningXiaPages = hash.match('/dataDefault') || [];
  if (loginPage.length > 0 || ningXiaPages.length > 0) {
    document.title = '数据分析平台';
    return true;
  }
  document.title = HOSPITAL_CONFIG.default.projectName;
  return false;
};

export const deepClone = (obj) => {
  if (obj === null || typeof obj !== 'object') {
    // 对于非对象类型和 null 直接返回
    return obj;
  }

  const newObj = Array.isArray(obj) ? [] : {};

  // eslint-disable-next-line no-restricted-syntax
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      newObj[key] = deepClone(obj[key]);
    }
  }

  return newObj;
};

export const Message = new Proxy(element.Message, {
  apply(target, thisArg, args) {
    let [options] = args;
    if (typeof options === 'string') {
      options = { message: options };
    }
    options.customClass = `${options.customClass || ''} element-dialog-top-index`;
    options.showClose = true;
    return target.apply(thisArg, [options]);
  },
  get(target, prop) {
    const originalMethod = target[prop];
    if (typeof originalMethod === 'function') {
      return function (this, ...args) {
        let [options] = args;
        if (typeof options === 'string') {
          options = { message: options };
        }
        if (options && typeof options === 'object') {
          options.customClass = `${options.customClass || ''} element-dialog-top-index`;
        }
        options.showClose = true;
        return originalMethod.apply(this, [options]);
      };
    }
    return originalMethod;
  },
});

export const getPassWordScore = (newPassword: string) => {
  let strengthScore = 0;
  if (newPassword) {
    strengthScore = newPassword?.length;
    const pattern1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\W_]{8,30}$/;
    const pattern2 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])[a-zA-Z\d\W_]{8,30}$/;
    const pattern3 = /^(?=.*[a-z])(?=.*\d)(?=.*[\W_])[a-zA-Z\d\W_]{8,30}$/;
    const pattern4 = /^(?=.*\d)(?=.*[A-Z])(?=.*[\W_])[a-zA-Z\d\W_]{8,30}$/;
    if (
      pattern1.test(newPassword)
      || pattern2.test(newPassword)
      || pattern3.test(newPassword)
      || pattern4.test(newPassword)
    ) {
      strengthScore > 10 && (strengthScore = 10);
    } else {
      strengthScore > 5 && (strengthScore = 5);
    }
  }
  return strengthScore;
};

export const isStrongPassword = (password: string) => getPassWordScore(password) >= 6;

export const isNetworkEnv = () => {
  const origin = window.location.origin;
  if (origin.includes('tengmed.com') || origin.includes('localhost')) {
    return true;
  }
  return false;
};

// 将选中id字符转换为展开id字符数组 '2-0-0' ->['2','2-0','2-0-0']
export const checkedKeys2ExpandedKeys = (str) => {
  const parts = str?.split('-') || [];
  const result: any = [];
  for (let i = 0; i < parts.length; i++) {
    result.push(parts?.slice(0, i + 1)?.join('-'));
  }
  return result;
};

// 中山医院的病历号展示规则
export const dealRegisterNos = (registerNos) => {
  const len = registerNos.length;
  if (len <= 1) {
    return registerNos.toString();
  }
  const reg = /^0000/;
  let flag = false;
  let registerNo = '';

  for (const item of registerNos) {
    if (reg.test(item)) {
      flag = true;
      registerNo = item;
      break;
    }
  }

  if (flag) {
    return registerNo;
  }
  return registerNos[0];
};

// 防抖函数
export const debounce = (fn, delay) => {
  let timer;
  return function (this: any, ...args: any[]) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
};

// 获取头像
export const getAvatar = (gender) => {
  const defaultUrl = defaultAvatar;
  const avatarUrls = [maleAvatar, femaleAvatar];
  return avatarUrls[gender] || defaultUrl;
};

// 格式化文件大小
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};
